import React, { useEffect } from 'react'
import blogServices from '../services/blogs'
import Blog from './Blog'

function CurrentBlogs ({ blogs, setBlogs, handleLogout, user }) {
  useEffect(() => {
    const effect = async () => {
      try {
        const returnedBlogs = await blogServices.loadBlogs()
        setBlogs(returnedBlogs)
      } catch (exception) {
        if (exception.response.status === 403) {
          window.alert("Session expired")
          handleLogout()
        }
        console.log(`exception: ${exception}`)
      }
    }
    effect()
  }, [])

  return (
    <>
      <div className="column">
        <h2>Current blogs</h2>  
        {blogs.map((blog) => (
          <Blog
            key={blog.id}
            blog={blog}
            blogs={blogs}
            setBlogs={setBlogs}
            handleLogout={handleLogout}
            user={user}
          />
        ))} 
      </div>
    </>
  )
}

export default CurrentBlogs